<template>
  <!-- 待派單 -->
  <el-table :data="orders" header-row-class-name="table-head">
    <div slot="empty" class="el-table__empty-text">暫無資料</div>

    <el-table-column prop="orderStatus" label="狀態" width="100px">
      <template slot-scope="scope">
        <div :class="getOrderStatusBadgeType(scope.row.orderStatus)">
          {{ defaultOption.orderStatusLookup[scope.row.orderStatus] }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="日期" width="80px">
      <template slot-scope="scope">
        {{ $moment(scope.row.estimateDate, 'YYYY/MM/DD').format('MM/DD') }}
      </template>
    </el-table-column>
    <el-table-column prop="estimateTime" label="時間" width="80px">
      <template slot-scope="scope">
        <span style="font-size: 20px; font-weight: bold">
          {{ $moment(scope.row.estimateTime, 'HH:mm').format('HH:mm') }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="乘客/電話" width="200px">
      <template slot-scope="scope">
        {{ scope.row.userName }} / {{ scope.row.contactNumber }}
      </template>
    </el-table-column>
    <el-table-column prop="area" label="行政區" width="80px"></el-table-column>
    <el-table-column
      prop="onLocation"
      label="上車地址"
      width="180px"
    ></el-table-column>
    <el-table-column
      prop="offLocation"
      label="下車地址"
      width="180px"
    ></el-table-column>
    <el-table-column prop="deliveryMethod" label="派單方式">
      <template slot-scope="scope">
        <el-select
          :value="String(scope.row.deliveryMethod)"
          placeholder="必填"
          @change="
            prepareOrder(
              scope.row.orderId,
              { deliveryMethod: $event },
              scope.$index,
            )
          "
        >
          <el-option
            v-for="item in defaultOption.deliveryMethodOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </template>
    </el-table-column>
    <el-table-column
      label="指定司機和車牌"
      :rowspan="2"
      class-name="driver-field"
    >
      <template slot-scope="scope">
        <DriverSelector
          :driver="scope.row.driver"
          @driver-updated="
            prepareOrder(scope.row.orderId, { ...$event }, scope.$index)
          "
          style="flex: 2; margin-right: 5px"
        />
      </template>
    </el-table-column>
    <el-table-column>
      <template slot-scope="scope">
        <DriverLicenseSelector
          v-if="scope.row.driver"
          :driver="scope.row.driver.licenseNumber"
          :preferParams="{ searchFields: 'license_number' }"
          @driver-license-updated="
            prepareOrder(
              scope.row.orderId,
              { driver: { ...scope.row.driver, licenseNumber: $event } },
              scope.$index,
            )
          "
          placeholder="注意：英文大寫，所有字母為半形字"
          style="flex: 1"
        />
      </template>
    </el-table-column>

    <el-table-column label="動作" width="80px">
      <template slot-scope="scope">
        <router-link
          :to="{
            name: 'longTermOrderDetail',
            params: { orderId: scope.row.orderId },
          }"
        >
          <el-button
            type="primary"
            size="mini"
            round
            plain
            style="padding-top: 1px; padding-bottom: 1px"
          >
            檢視
          </el-button>
        </router-link>
        <el-button
          type="success"
          size="mini"
          round
          plain
          style="padding-top: 1px; padding-bottom: 1px; margin-top: 5px"
          @click="save(scope.row.orderId)"
        >
          送出
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import is from 'is_js'
import { defaultOption } from './defaultOption'
import driverMixin from './_DriverMixin'
import longTermCareService from '@/API/longTermCareService'
export default {
  mixins: [driverMixin],
  props: {
    orders: Array,
  },
  data() {
    return { defaultOption, editingOrder: {} }
  },
  methods: {
    getOrderStatusBadgeType: (state) => {
      let badgeType = ''
      switch (state) {
        case 0:
        case 1:
          badgeType = 'success'
          break
        case 2:
        case 3:
          badgeType = 'primary'
          break
        // case 7: //即將載客
        //   return 'warning'
        // case 8: //逾期
        //   return 'danger'
        case 4:
        case 5:
        default:
          badgeType = ''
      }

      return `status-badge status-badge__${badgeType}`
    },
    prepareOrder(id, data = {}, idx) {
      if (!id) return this.$message.error('order id 有誤')
      const pre = this.editingOrder[id] || {}
      this.$set(this.editingOrder, id, { ...pre, ...data })

      // FIXME: bad solution and interface
      if (data.deliveryMethod) {
        this.orders[idx].deliveryMethod = data.deliveryMethod
      }
      if (data.driver) {
        this.orders[idx].driver = data.driver
      }
    },
    save(id) {
      if (!id || !this.editingOrder[id])
        return this.$message.error('無法儲存，請檢查輸入資料')

      const {
        deliveryMethod,
        driver: { id: driverId, licenseNumber },
      } = this.editingOrder[id]
      longTermCareService
        .updateOrderAssignDriver(id, driverId, licenseNumber)
        .then((data) => {
          console.log(data)
          this.$message.success(data.message)
          this.$emit('reload')
        })
        .catch(({ data: { error }, message }) =>
          this.$message.error(message || error.message),
        )
    },
  },
}
</script>
<style scoped>
.table-head {
  background: #eee;
}
.driver-field > .cell {
  display: flex;
  align-items: center;
}

.table-header > th,
.table-header > tr {
  font-weight: 400;
  background: #eee !important;
}
.status-badge {
  border: 2px solid;
  padding: 4px 8px;
  text-align: center;
  width: 100%;
  color: #606266;
  border-color: #606266;
  border-radius: 3px;
}
.status-badge__success {
  color: #67c23a;
  border-color: #67c23a;
}
.status-badge__primary {
  color: #00c0ef;
  border-color: #00c0ef;
}
.status-badge__warning {
  color: #f39c12;
  border-color: #f39c12;
}
.status-badge__danger {
  color: #f56954;
  border-color: #f56954;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/_DriverAwaitStatusOrderList.vue